module.exports = __webpack_public_path__ + "img/owidplus_logo.2f60da06.svg";